<template>
    <div> 


很多链接可以做到这个debug 这里来

        <div class="debug">uid : {{info.uid}}</div>
        <div class="debug">pid : {{info.pid}}</div>
        <div class="debug">utoken : {{info.utoken}}</div>
        <div class="debug">qdcode : {{info.qdcode}}</div>
        <div class="debug">ranking : {{info.ranking}}</div>
        <div class="debug">notice : {{info.notice}}</div>
        <div class="debug">link : {{info.link}}</div>

        <button class="debugbutton" @click="goTo('/order/cashpay')">goCashpay</button>
        <button class="debugbutton" @click="goTo('/')">goIndex</button>
        <button class="debugbutton" @click="goTo('/donate')">goDonate</button>
        <button class="debugbutton" @click="setToken">setToken</button>
        <button class="debugbutton" @click="delToken">del-token</button>
        <button class="debugbutton" @click="delUid">del-uid</button>
        <button class="debugbutton" @click="delPid">del-pid</button>
        <button class="debugbutton" @click="delQdcode">del-qdcode</button>
        <button class="debugbutton" @click="setShare">set-share</button>
        <button class="debugbutton" @click="set1v1()">set-1v1</button>
        <button class="debugbutton" @click="setHeart()">set-heart</button>
        <button class="debugbutton" @click="setQuan()">set-quan</button>
        <!-- <div>debugtbs.qq.com</div> -->
        
        
        <div style="background-color: #FEFEFE;clear: both;text-align: center;">
            自定义分享
            <br>
            <input type="text" placeholder="title" v-model="share.title"/>
            <br>
            <input type="text" placeholder="desc" v-model="share.desc"/>
            <br>
            <input type="text" placeholder="url" v-model="share.url"/>
            <br>
            <input type="text" placeholder="image" v-model="share.image"/>
        </div>
        
        
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        
    </div>
</template>
<script>

    //import sy from "@/sy";
    import wx from 'weixin-js-sdk';

    export default {
        name: "sys",
        data() {
            return {
                info:{},
                abc: "wu",
                range1: 0,
                range2: 0,
                share:
                {
                    title: '资料登记',
                    desc: '美遇 - 遇见真实的灵魂！',
                    url: 'https://wx.meet2020.cn/regist?qdcode=share&pid=32',
                    image: 'www.symeet.xyz/share_index.jpg',
                }
            };
        },
        methods: {
            debug: function()
            {
                let map =
                [
                    'uid', 'pid', 'utoken', 'qdcode', 'ranking', 'notice',
                ];
                let info = {};
                for(var i in map)
                {
                    let k = map[i]
                    let v = localStorage.getItem(k);
                    if( v === null )
                    {
                        v = 'null';
                    }
                    info[k] = v;
                }

                info.link = location.href;

                this.info = info;
            },
            setToken: function() {
                var utoken = prompt("你要多少折扣?","59fbdbfd0687s17dt8xkob");
                localStorage.setItem('utoken', utoken);
                this.debug();
            },
            delToken: function() {
                localStorage.removeItem('utoken');
                this.debug();
            },
            delQdcode: function() {
                localStorage.removeItem('qdcode');
                this.debug();
            },
            delUid: function() {
                localStorage.removeItem('uid');
                this.debug();
            },
            delPid: function() {
                localStorage.removeItem('pid');
                this.debug();
            },

			goTo: function(to)
			{
				location.href = to;
			},

            set1v1: function()
            {
                this.share.url = 'https://wx.meet2020.cn/1v1/regist?qdcode=share&pid=32';
                
                this.setShare();
            },
            setHeart: function()
            {
                this.share.title = '5+1心选行动',
                this.share.desc = '期待和你遇见',
                this.share.url = 'https://qrcode.syzing.com/qrcode/210824.html',
                this.share.image = 'www.symeet.xyz/vue/xindonghuxuan.jpg',                

                this.setShare();
            },
            setQuan: function()
            {
                this.share.title = '脱单星球',
                this.share.desc = '约跑、约球、约伴、发现三观一致的小伙伴',
                this.share.url = 'https://qrcode.syzing.com/qrcode/102.html',
                this.share.image = 'www.symeet.xyz/vue/xindonghuxuan.jpg',                

                this.setShare();
            },
            setShare: function()
            {
                let $_this = this;
                let link = $_this.share.url;
                let title = $_this.share.title;
                let desc = $_this.share.desc; // 总有一天,我们终将遇见//人海茫茫,我们终将相遇//与君初相识,犹如故人归
                let imgUrl = $_this.share.image;
                wx.ready(function()
                {
                    wx.updateAppMessageShareData({
                        title: title, // 分享标题
                        desc: desc, // 分享描述
                        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: imgUrl, // 分享图标
                        success: function() {
                            // 设置成功
                        }
                    });
                    wx.updateTimelineShareData({
                        title: title + ' - ' + desc, // 分享标题
                        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: imgUrl, // 分享图标
                        success: function() {
                            // 设置成功
                        }
                    });                    
                    wx.hideMenuItems({
                        menuList:
                        [
                            'menuItem:share:qq',
                            'menuItem:share:QZone',
                            'menuItem:share:weiboApp',
                            'menuItem:share:faceboo',
                            'menuItem:copyUrl',
                            'menuItem:originPage',
                            'menuItem:openWithQQBrowser',
                            'menuItem:openWithSafari',
                        ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                    });
                });
            },
        },
        created()
        {
			
			
			
			// console.log(navigator);
			// alert(navigator.appCodeName);
            this.debug();
            // this.open();
            //this.wxReady();
            // this.province = 0; 
			
        }, 
        mounted(){},
        activated()
        {
            
        },
    };


</script>
<style>
    .debugbutton
    {
        display: block;
        width: 6rem;
        margin: 1rem 1rem;
        padding: 1rem 0rem;

        float: left;
        font-size: 1rem;
    }
    .debug
    {
        margin: 0.5rem 0rem 0 2rem;
    }
</style>